module.exports = __webpack_public_path__ + "static/media/loading.6f6ae706.svg";